// models/metrics/metasearchMetrics/google-hotel-ads-fbl/googleHotelAdsMetrics.js

// connectivity
import MetricHotelSuspendedCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricHotelSuspendedCount";
import MetricNoAvailabilityCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricNoAvailabilityCount";
import MetricNoLandingPageCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricNoLandingPageCount";
import MetricNoPriceCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricNoPriceCount";

// conversion
import MetricConversionGha from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/conversion/MetricConversion";
import MetricBookingcount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/conversion/MetricBookingCount";

// performance
import MetricClicksGha from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricClicks";
import MetricCpc from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricCpc";
import MetricCsr from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricCsr";
import MetricCtrGha from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricCtr";
import MetricRevenuePerClick from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricRevenuePerclick";
import MetricRoi from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricRoi";

// visibility
//hotel_impr ?
// others
import MetricGenerated from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricGenerated";
import MetricImpr from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricImpr";
import MetricLivePricingConfigIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricLivePricingConfigIssueCount";
import MetricLivePricingNotAvailableCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricLivePricingNotAvailableCount";
import MetricLivePricingNotTriggeredCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricLivePricingNotTriggeredCount";
import MetricLivePricingOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricLivePricingOtherReasonCount";
import MetricLivePricingTechnicalIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricLivePricingTechnicalIssueCount";
import MetricMissedParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricMissedParticipationCount";
import MetricNoTaxBreakdownCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricNoTaxBreakdownCount";
import MetricOpportunityCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/visibility/MetricOpportunityCount";
import MetricOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricOtherReasonCount";
import MetricParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricParticipationCount";
import MetricParticipationPercentRate from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/connectivity/MetricParticipationPercentRate";
import MetricSpent from "models/metrics/metasearchMetrics/google-hotel-ads-fbl/performance/MetricSpent";

const googleHotelAdsMetricsFbl = [
    // connectivity
    new MetricHotelSuspendedCount(),
    new MetricNoAvailabilityCount(),
    new MetricNoLandingPageCount(),
    new MetricNoPriceCount(),
    // conversion
    new MetricConversionGha(),
    new MetricBookingcount(),
    // performance
    new MetricClicksGha(),
    new MetricRevenuePerClick(),
    new MetricRoi(),
    new MetricCpc(),
    new MetricCsr(),
    new MetricCtrGha(),
    // visibility

    //hotel_impr ?
    // others
    new MetricGenerated(),
    new MetricImpr(),
    new MetricLivePricingConfigIssueCount(),
    new MetricLivePricingNotAvailableCount(),
    new MetricLivePricingNotTriggeredCount(),
    new MetricLivePricingOtherReasonCount(),
    new MetricLivePricingTechnicalIssueCount(),
    new MetricMissedParticipationCount(),
    new MetricNoTaxBreakdownCount(),
    new MetricOpportunityCount(),
    new MetricOtherReasonCount(),
    new MetricParticipationCount(),
    new MetricParticipationPercentRate(),
    new MetricSpent(),

];

export function findMetricById(metricId) {
    return googleHotelAdsMetricsFbl.find((metricClass) => metricClass.field === metricId);
}

export default googleHotelAdsMetricsFbl;
